import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { ArkUnitOfWork, AppInformationService, AuthService } from 'app/core/core.module';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Guid } from '../../core/data/entities';
import { confirm, alert } from 'devextreme/ui/dialog';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-message-text-detail',
    templateUrl: './text-detail.component.html',
    styleUrls: ['./text-detail.component.scss'],
    imports: [DevExtremeModule]
})
export class TextDetailComponent implements OnInit {
    message: any;
    messageId: number | string;
    link: any;
    mode: string;
    groups: any[];
    baseHref = environment.baseHref;
    serviceName = environment.serviceName;
    totalRecipients = 0;
    group: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private uow: ArkUnitOfWork,
        private http: HttpClient,
        private appInfo: AppInformationService,
        private auth: AuthService
    ) {}

    async ngOnInit() {
        this.mode = this.route.snapshot.data['mode'];
        this.messageId = this.route.snapshot.params['id'];
        if (this.messageId === 'new') {
            this.message = this.uow.textMessages.createEntity({ created: new Date() });
            this.message.defaultHeader = 'Graafschap CRC - No Reply';
            // this.message.defaultFooter = 'Info at www.graafschap.org/info Reply STOP to unsubscribe';
            this.message.defaultFooter = 'Reply STOP to unsubscribe';
            this.message.fromUserId = this.auth.currentUser.id;
            this.link = this.uow.textGroupLinks.createEntity();
            this.link.messageId = this.message.id;
            this.groups = await this.getGroups();
            return;
        }

        await this.getData();
    }

    async getData() {
        [this.message, this.groups] = await Promise.all([this.uow.textMessages.byId(this.messageId), this.getGroups()]);

    }

    private getGroups() {
        return this.uow.groups.all('name', 'groupPersons');
    }

    async save() {
        await this.uow.commit();
        this.close();
    }

    async groupSelectionChanged(e) {
        let memberCount = 0;
        this.group = e.selectedItem;
        if (!!this.group && this.group.code === 'UseMembers') {
            memberCount = await this.uow.getTextMessageMemberCount();
        }

        this.totalRecipients = this.group.groupPersons.length + memberCount ;
    };

    close() {
        this.router.navigate(['../'], { relativeTo: this.route });
    }

    cancel() {
        this.uow.rollback();
        this.close();
    }

    async send() {
        if (!this.message.toGroupId) {
            this.appInfo.pleaseWait = false;
            await (<Promise<any>>alert('Need to have a group selected', 'Error'));
            return;
        }
        if (!this.message.body) {
            this.appInfo.pleaseWait = false;
            await (<Promise<any>>alert('There was no main message', 'Error'));
            return;
        }
        const dialogResult = await (<Promise<boolean>>confirm('Are you sure you want to send this message?', 'Ready to Send'));
        if (!dialogResult) return;

        this.appInfo.pleaseWait = true;
        const message = `${this.message.defaultHeader}\n\n${this.message.body}\n\n${this.message.defaultFooter}`;
        const groupId = this.message.toGroupId;
        this.link.toGroupId = groupId;
        await this.uow.commit();



        const sid = (await this.http.post(environment.serviceName + '/textMessaging/textMessage', { message, groupId, messageId: this.message.id }).toPromise()) as any;
        // console.log('complete', sid);

        this.appInfo.pleaseWait = false;

        if (sid.couldNotSendToNumbers.length > 0) {
            let couldNotSendMessage = '';
            sid.couldNotSendToNumbers.forEach((number) => {
                couldNotSendMessage += `${!couldNotSendMessage ? '' : couldNotSendMessage}${number}'<br>'`;
            });
            await (<Promise<any>>alert(couldNotSendMessage, 'Could Not Send To'));
        }
        await (<Promise<any>>alert(`Message sent${sid.couldNotSendToNumbers.length > 0 ? ' to everyone else' : ''}!`, 'Complete'));

        this.message.sent = new Date();
        // await this.uow.commit();

        // this.group.groupPersons.forEach(person => {
        //     const textSend = this.uow.textMessageSents.createEntity() as any;
        //     textSend.messageId = this.message.id;
        //     textSend.personId = person.personId;
        // });
        await this.uow.commit();

        this.close();
    }
}
